import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { AdminLayout } from "@/components/layout/AdminLayout";
import { Card, CardContent } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { Users, Clock, ListChecks, Library, Repeat, ShieldCheck, CheckCircle2, XCircle } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    adminApi.get("/admin/dashboard/stats").then((r) => setStats(r.data));
  }, []);

  const cards = stats ? [
    { label: "Total Clients", value: stats.total_clients, icon: Users },
    { label: "Pending KYC", value: stats.pending_kyc, icon: Clock },
    { label: "Approved Clients", value: stats.approved_clients, icon: CheckCircle2 },
    { label: "Total Orders", value: stats.total_orders, icon: ListChecks },
    { label: "Payment Pending", value: stats.payment_pending, icon: Clock },
    { label: "Allotted", value: stats.allotted, icon: CheckCircle2 },
    { label: "Rejected", value: stats.rejected, icon: XCircle },
    { label: "Active SIPs", value: stats.active_sips, icon: Repeat },
    { label: "Active XSIPs", value: stats.active_xsips, icon: ShieldCheck },
    { label: "Active STPs", value: stats.active_stps, icon: Repeat },
    { label: "Active SWPs", value: stats.active_swps, icon: Repeat },
    { label: "Schemes in Master", value: stats.total_schemes, icon: Library },
  ] : [];

  const chartData = stats ? Object.entries(stats.order_status_distribution || {}).map(([status, count]) => ({ status, count })) : [];

  return (
    <AdminLayout>
      <h1 className="mb-6 font-heading text-3xl text-[var(--brand)]">Overview</h1>
      <div className="mb-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-5">
        {cards.map((c) => (
          <Card key={c.label} className="glass-card border-0" data-testid={`admin-stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <CardContent className="p-4">
              <c.icon className="h-4 w-4 text-[var(--cta)]" />
              <div className="mt-2 font-heading text-2xl text-[var(--brand)]">{c.value}</div>
              <div className="text-xs text-[var(--ink-muted)]">{c.label}</div>
            </CardContent>
          </Card>
        ))}
      </div>

      <Card className="border-[var(--glass-border)]">
        <CardContent className="p-6">
          <h2 className="mb-4 font-heading text-lg text-[var(--brand)]">Order status distribution</h2>
          <ResponsiveContainer width="100%" height={280} minWidth={0}>
            <BarChart data={chartData}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e5efe9" />
              <XAxis dataKey="status" tick={{ fontSize: 11 }} />
              <YAxis allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="count" fill="#098C62" radius={[6, 6, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </CardContent>
      </Card>
    </AdminLayout>
  );
}
